import { Response as fetchResponse } from 'node-fetch'

export const parseJSON = (response: fetchResponse) => response.text().then((text) => (text ? JSON.parse(text) : null))

export const safeParseJSON = (str: string) => {
  try {
    return JSON.parse(str)
  } catch {
    return undefined
  }
}
